// extracted by mini-css-extract-plugin
module.exports = {"chip":"Chip_chip__Dwhco"};